import { FC } from "react";
import AnalyticsOverview from "@/features/analytics/components/analytics.overview";
import useDocumentTitle from "@/hooks/useDocumentTitle";

const AnalyticsPage: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Analytics");

  return <AnalyticsOverview />;
};

export default AnalyticsPage;
